import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import LoadScript from 'vue-plugin-load-script';
import firebase from "firebase/app";
import VueAnalytics from 'vue-analytics';
import "firebase/auth";


Vue.use(LoadScript);
//*
const firebaseConfig = {
  apiKey: "AIzaSyAWhazOPmt6IbsLmMbQGPiAcSobVqmxdfk",
  authDomain: "xchat-2b2c3.firebaseapp.com",
  databaseURL: "https://xchat-2b2c3.firebaseio.com",
  projectId: "xchat-2b2c3",
  storageBucket: "xchat-2b2c3.appspot.com",
  messagingSenderId: "411860258946",
  appId: "1:411860258946:web:366c96ab1a69796f"
};
/*/
const firebaseConfig = {
  apiKey: "AIzaSyCLI70DVJ5ChynVlZZJjyIvUDNCNz2YpLM",
  authDomain: "xchat-dev.firebaseapp.com",
  databaseURL: "https://xchat-dev.firebaseio.com",
  projectId: "xchat-dev",
  storageBucket: "xchat-dev.appspot.com",
  messagingSenderId: "674282266247",
  appId: "1:674282266247:web:a685286840c713d8e6e222"
};
//*/
firebase.initializeApp(firebaseConfig);
(async function() {
  await Vue.loadScript("https://js.stripe.com/v3/")
  // other things after script loaded
})(); 

Vue.use(VueSkycons, {
  color: "#1e88e5",
});

Vue.config.productionTip = false;
Vue.use(Vuebar);

Vue.use(VueAnalytics, {
  id: 'UA-128884392-10',
  router
});


new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
